export default __webpack_public_path__ + "static/media/AltoLogo_128x128.58eed191.jpg";